export default __webpack_public_path__ + "static/media/bee.4db2fef9.png";